import * as React from 'react';
import { Typography } from '@mui/material';
import {
    ContextActionType,
    ModalContext,
    useDumbActionsContext,
} from '@europrocurement/flexy-components';
import { ColumnDatatable } from '@europrocurement/flexy-datatable';
import { useDispatch } from 'react-redux';
import { ChampComplMentaireJsonldChampcomplementaireReadHtmlFieldTypeEnum } from '@europrocurement/l2d-domain/openApi/ApiOffre';
import { addItem, FaOptionIcon } from '@europrocurement/l2d-icons';
import { useOffreService } from '@europrocurement/l2d-domain';
import { useDefaultContextActions } from '@europrocurement/l2d-modules/hooks';
import ListingWithSearchAndPreview from '../components/ListingWithSearchAndPreview';
import Form from './Form';

import { getStringColumn } from '../listings';
import { getHtmlFieldTypeLabel } from '../forms/htmlFields';
import { PossibleTypes } from '../../Societes';

const Panel: React.FunctionComponent = function () {
    const { modalActions } = React.useContext(ModalContext);

    const { offerGroupModel: model } = useOffreService();
    const { backContextActions } = useDefaultContextActions();

    const dispatch = useDispatch();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const reloadList = () => dispatch(model.datasourcesThunks.main.getData({}) as any);

    const listingButton = {
        label: 'Créer un nouveau champ complémentaire',
        icon: addItem,
        action: () =>
            modalActions.call(
                <Form
                    isCreate
                    afterSubmit={reloadList}
                />,
            ),
    };

    const contextActions: ContextActionType[] = React.useMemo(
        () => [
            {
                name: 'Créer un nouveau champ complémentaire',
                icon: <FaOptionIcon icon={['fas', 'plus-circle']} />,
                action: listingButton.action,
            },
            ...backContextActions,
        ],
        [backContextActions, listingButton.action],
    );

    useDumbActionsContext(contextActions);

    const columns: ColumnDatatable[] = [
        getStringColumn('id'),
        getStringColumn('libelle', 'Libellé'),
        getStringColumn('description'),
        {
            label: 'Type de champ HTML',
            displayLabel: true,
            render: (item: {
                htmlFieldType: ChampComplMentaireJsonldChampcomplementaireReadHtmlFieldTypeEnum;
            }) => (
                <Typography
                    variant="l2dtableCell"
                    color="text.gris70"
                >
                    {getHtmlFieldTypeLabel(item.htmlFieldType)}
                </Typography>
            ),
            isDisplayed: true,
            sortable: false,
            field: 'htmlFieldType',
        },
    ];

    return (
        <ListingWithSearchAndPreview
            listingTitle="Liste des champs complémentaires"
            listingButton={listingButton}
            listingColumns={columns}
            form={Form}
            model={model}
            filtersControl={false}
            searchBarType={PossibleTypes.ComplementaryField}
        />
    );
};

export default Panel;
